/**
 *Created by jmmartinez on 28/05/2019
 * v.1.1 25/10/2019 Añadida función filtrarDatosPagina
 * v.1.2 06/11/2019 Añadido id="barras" en getGraph en el <div>
 **/

import React from 'react'
import {
    CELLTIPO_CADENA,
    CELLTIPO_ENTERO,
    CELLTIPO_FLOTANTE,
    CELLTIPO_MONEDA,
    CELLTIPO_PORCENTAJE,
} from "../UI/TiposCeldas";
import TartaResponsive from "../../nivo/TartaResponsive";
import BarrasResponsive from "../../nivo/BarrasResponsive";

const getCellTipo= (dataTableTipo) => {
    switch (dataTableTipo){
        case "CADENA": return CELLTIPO_CADENA;
        case "ENTERO": return CELLTIPO_ENTERO;
        case "FLOTANTE": return CELLTIPO_FLOTANTE;
        case "PORCENTAJE": return CELLTIPO_PORCENTAJE;
        case "MONEDA": return CELLTIPO_MONEDA;
        default: return CELLTIPO_CADENA;
    }
}

export const getColumnas= (datosDataTable) => {
    //console.log(datosDataTable);
    let columnasUI= datosDataTable.columnasUI;

    let newColumnas= [];
    Object.keys(columnasUI).forEach( (propiedad) => {
        let columna= columnasUI[propiedad];
        let newColumna= {campo: columna.nombre.toUpperCase(), titulo: columna.titulo,
            tipo: getCellTipo(columna.columnaTipo),
            ancho: columna.ancho,
            coloreador: columna.coloreador };
        newColumnas.push(newColumna);
    });

    return newColumnas;
}



export const getDatos= (datosDataTable) => {
    //console.log(datosDataTable);

    let newDatos= [];
    datosDataTable.rows.forEach( (row) => {
        let newRow= {};
        Object.keys(row.propiedades).forEach( (propiedad) => {
            newRow[propiedad]= row.propiedades[propiedad];
        });
        if (row.esPie)
            newRow.esPie= true;
        newDatos.push(newRow);
    });

    return newDatos;
}

export const filtrarDatosPagina= (datos, offset, numElementos) => {

    console.log("FILTRAR DATOS PAGINA");
    //console.log(datos);
    console.log("offset -> " + offset);
    console.log("numElementos -> " + numElementos);

    let newDatos= [];
    for (let i= offset ; i < offset + numElementos ; i++ ){
        if (i < datos.length)
            newDatos.push(datos[i]);
    }
    return newDatos;
}


export const getGraph= (datosDataTable) => {
    if (datosDataTable.graphUI) {
        if (datosDataTable.graphUI.tipo === "TARTA" ) {
            const campoNombre = datosDataTable.graphUI.campoNombre.toUpperCase();
            const camposValor = datosDataTable.graphUI.campoValor.toUpperCase();
            const umbralVarios = datosDataTable.graphUI.umbralVarios;
            return (
                <div id="tarta" style={{height: 400}}>
                    <TartaResponsive datos={datosDataTable}
                                     campoNombre={campoNombre}
                                     campoValor={camposValor}
                                     umbralVarios={umbralVarios}
                                     mostrarLeyenda={false}/>
                </div>);
        }
        if (datosDataTable.graphUI.tipo === "BARRAS" ) {
            //console.log("BARRAS");
            //console.log(datosDataTable.graphUI);
            const campoNombre = datosDataTable.graphUI.campoNombre.toUpperCase();
            const camposValor = datosDataTable.graphUI.camposValor;
            const camposValorLeyenda = datosDataTable.graphUI.camposValorLeyenda;
            const tituloEjeX = datosDataTable.graphUI.tituloEjeX;
            const tituloEjeY = datosDataTable.graphUI.tituloEjeY;
            return (
                <div id="barras" style={{height: 400}}>
                    <BarrasResponsive datos={datosDataTable}
                                     campoNombre={campoNombre}
                                     camposValor={camposValor}
                                     camposValorLeyenda={camposValorLeyenda}
                                     tituloEjeX={tituloEjeX}
                                     tituloEjeY={tituloEjeY}
                    />
                </div>);
        }
    }
    else
        return <div/>;
}